const Dynamic = {
    namespaced: true,
    state: {
        searchKeyWord: '',
        searchFlag:[],
    },
    mutations: {
        SETKEYWORD(state, data) {
            state.searchKeyWord = data
        },
        SETFLAG(state, data) {
            state.searchFlag = data
        },
        SETFLAGDATA(state, data){
            state.searchFlag[data] = false
        },
    },
    actions: {},
    getters: {},
}
export default Dynamic